<template>
  <v-layout row wrap v-if="data">
    <v-flex xs12 text-xs-center title>
      运动报告
    </v-flex>

    <v-flex xs12 mt-2 mb-2>
      <v-divider></v-divider>
    </v-flex>

    <v-flex xs6 md4 class="outline">
      <div>报告日期:</div>
      <div>开始时间:</div>
      <div>总时间:</div>
    </v-flex>

    <v-flex xs6 md8>
      <div>{{ data.timeStart | yymmddFormat }}</div>
      <div>{{ data.timeStart | hhmmssFormat }}</div>
      <div>{{ data.duration | secondsToHHMMSS }}</div>
    </v-flex>

    <v-flex xs12 mt-2 mb-2>
      <v-divider></v-divider>
    </v-flex>

    <v-flex xs4>
      <div>平均脉率(bpm): </div>
      <div>最大脉率(bpm): </div>
      <div>最小脉率(bpm): </div>
    </v-flex>

    <v-flex xs8>
      <div> {{ data.prAvg }} </div>
      <div> {{ data.prMax }} </div>
      <div> {{ data.prMin }} </div>
    </v-flex>

    <v-flex xs12 mt-2 mb-2>
      <v-divider></v-divider>
    </v-flex>

    <v-flex xs12>
      <div>脉率趋势图</div>

      <ve-line :data="chartDataPr" :colors="colorsPr" :loading="loading"
        :grid="grid"
        :mark-line="markLine"
        :tooltip-visible="false"
        :legend-visible="false"
        height="250px"
        :settings="chartSettings"
        :extend="chartExtendPr"></ve-line>
    </v-flex>
  </v-layout>
</template>

<script>
import { dateFormat } from '@/utils/Util'
import 'v-charts/lib/style.css'
import 'echarts/lib/component/markLine'

function format (date) {
  let h = date.getHours()
  h = h < 10 ? ('0' + h) : h
  let m = date.getMinutes()
  m = m < 10 ? ('0' + m) : m
  return h + ':' + m
}

function minBottom (v, min) {
  const tmp = Math.floor(v / 10) * 10
  return tmp - 10 < min ? min : tmp
}

function maxTop (v, max) {
  const tmp = Math.ceil(v / 10) * 10
  return tmp + 10 > max ? max : tmp
}

export default {
  props: [
    'data'
  ],
  data () {
    this.chartSettings = {}
    this.colorsSpo = ['#00a3fb']
    this.colorsPr = ['#00c651']

    this.chartExtendPr = {
      animation: false,
      xAxis: {
        axisLabel: {
          formatter: function (value, index) {
            var t = new Date(value * 1000)
            return format(t)
          }
        }
      },
      yAxis: {
        min (v) {
          // return v.min - 10 < 30 ? 30 : v.min - 10
          return minBottom(v.min, 30)
        },
        max (v) {
          // return v.max + 10 > 240 ? 240 : v.max + 10
          return maxTop(v.max, 240)
        },
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        }
      },
      series: {
        showSymbol: false,
        lineStyle: {
          normal: {
            // color: ,
            width: 1
          }
        }
      }
    }

    this.markLine = {
      data: [],
      symbol: 'image://',
      silent: true,
      label: {
        normal: {
          position: 'end',
          formatter: function () {
            return ''
          }
        }
      },
      lineStyle: {
        normal: {
          color: '#333'
        }
      }
    }
    this.grid = {
      top: 20,
      bottom: 30
    }
    return {
      chartDataPr: {
        columns: ['时间', 'pr'],
        rows: []
      },
      loading: true
    }
  },
  filters: {
    floatToFixed (value) {
      return Number(value).toFixed(2)
    },
    percentFormat (value) {
      return (value * 100).toFixed(2)
    },
    secondsToHHMMSS (value) {
      if (value <= -1) {
        return '(无有效数据)'
      }
      return new Date(value * 1000).toUTCString().slice(-12, -4)
    },
    yymmddFormat (value) {
      return dateFormat(new Date(value * 1000), 'yyyy-MM-dd')
    },
    hhmmssFormat (value) {
      return dateFormat(new Date(value * 1000), 'hh:mm:ss')
    }
  },
  mounted: function () {
    const startTime = this.data.timeStart
    // 处理-血氧解析
    const totalLen = this.data.prArr.length
    const rowsPr = []
    for (let i = 0; i < totalLen; i++) {
      rowsPr.push({'时间': startTime + i, 'pr': this.data.prArr[i] || ''})
    }
    this.chartDataPr.rows = rowsPr
    console.log('this.chartDataPr.rows', this.chartDataPr.rows)
    this.markLine.data = this.data.handOffArr.map(v => ({ xAxis: v }))
    this.loading = false
  }
  // watch: {
  //   data (res) {
  //     console.log('watch')
  //     if (!res) {
  //       return
  //     }
  //     const startTime = res.timeStart

  //     // 处理-血氧解析
  //     const totalLen = res.prArr.length
  //     const rowsPr = []
  //     for (let i = 0; i < totalLen; i++) {
  //       rowsPr.push({'时间': startTime + i, 'pr': res.prArr[i] || ''})
  //     }
  //     this.chartDataPr.rows = rowsPr
  //     console.log('this.chartDataPr.rows', this.chartDataPr.rows)
  //     this.markLine.data = res.handOffArr.map(v => ({ xAxis: v }))
  //     this.loading = false
  //   }
  // }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ParsedSportPanel.vue